export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=4025b1de1d37ed24ced3bb73f5806f5bf3a4afebdc&name=revalidateCommunity!'